import _ from 'lodash';
import axios from 'axios';
import Pusher from 'pusher-js';

window._ = _;
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.Pusher = Pusher;
